import { Api } from "../axios-config";

export type GetCapitalizationFollowupNotesResponse = {
    id: string;
    userId: string;
    userName: string;
    createdAt: Date;
    note: string;
};

export type CapitalizationFollowUpContactType = {
    id: string;
    email: string;
};

const getCapitalizationFollowupNotes = async (capitalizationId: string): Promise<GetCapitalizationFollowupNotesResponse[]> => {
    try {
        const { data } = await Api().get(`/capitalization-followup/${capitalizationId}/notes`);

        if (data) return data;

        throw new Promise((_, reject) => reject(new Error("Erro ao carregar os followups.")));
    } catch (error) {
        console.error(error);
        throw new Promise((_, reject) => reject(error));
    }
};

const addCapitalizationFollowupNote = async (capitalizationId: string, formattedNote: string): Promise<void> => {
    try {
        const { data } = await Api().post(`/capitalization-followup/notes`, {
            capitalizationId,
            formattedNote,
        });

        if (data) return data;

        throw new Promise((_, reject) => reject(new Error("Erro ao adicionar followup.")));
    } catch (error) {
        console.error(error);
        throw new Promise((_, reject) => reject(error));
    }
};

const getCapitalizationFollowupContacts = async (capitalizationId: string): Promise<CapitalizationFollowUpContactType[]> => {
    try {
        const { data } = await Api().get(`/capitalization-followup/${capitalizationId}/contacts`);
        if (data) return data;

        throw new Promise((_, reject) => reject(new Error("Erro ao carregar emails de contato!")));
    } catch (error) {
        console.error(error);
        throw new Promise((_, reject) => reject(error));
    }
};

const addCapitalizationFollowupContact = async (capitalizationId: string, email: string): Promise<void> => {
    try {
        const { data } = await Api().post(`/capitalization-followup/contacts`, {
            capitalizationId,
            email,
        });
        if (data) return data;
    } catch (error) {
        console.error(error);
        throw new Promise((_, reject) => reject(error));
    }
};

const removeCapitalizationFollowupContact = async (contactId: string): Promise<void> => {
    try {
        await Api().delete(`/capitalization-followup/contacts/${contactId}`);
    } catch (error) {
        console.error(error);
        throw new Promise((_, reject) => reject(error));
    }
};

export const CapitalizationFollowUpService = {
    getCapitalizationFollowupNotes,
    addCapitalizationFollowupNote,
    getCapitalizationFollowupContacts,
    addCapitalizationFollowupContact,
    removeCapitalizationFollowupContact,
};
